export default class Cookies {
    setCookie(cname, cvalue, exdays) {
        let date = new Date();

        date.setTime(date.getTime() + (exdays*24*60*60*1000));

        let expires = `expires=${date.toUTCString()}`;

        document.cookie = `${cname}=${cvalue};${expires};secure;path=/`;
    }

    getCookie(cname) {
        const name = `${cname}=`;

        let decodedCookie = decodeURIComponent(document.cookie);
        let cookiesArray = decodedCookie.split(';');

        for(let i = 0; i <cookiesArray.length; i++) {
            let cookie = cookiesArray[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }

            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return '';
    }
}
